module.exports = __webpack_public_path__ + "img/andorra.dbc9fb7f.svg";